const roundValue = (value, precision = 3) => Math.ceil(value * 10 ** precision) / 10 ** precision

export default roundValue
